<template>
  <div class="main-footer-wrapper">
    <v-checkbox v-model="flags.isChecked" :rules="rules.checkbox" label="" color="#0078A7" value="#0078A7" dense
      id="disclaimer" v-if="!shouldHideConsent">
      <template v-slot:label>
        <p class="check-disclaimer" v-html="isSingleMemberLLC
          ? 'I agree that I am the sole beneficial owner and controller or manager.'
          : `I understand that by clicking ‘continue’ I certify that I have significant responsibility to control, <br /> manage and direct the business`
        "></p>
      </template>
    </v-checkbox>
    <div v-if="!isSumOwnersPercentValid" class="error-wrapper">
      <span class="error-icon" />
      <p class="footer-error">Total ownership percentage exceeds 100%</p>
    </div>

    <div class="partner-business-footer-wrapper">
      <h3 v-if="!isMultiBusinessFlow && !isMobile" @click="handleBack"
        class="form-footer-back -helper--flex align-center" id="elNavBackDesktop">
        {{ $t('navBack') }}
      </h3>
      <v-btn class="main-app-cta active-cta" elevation="0" @click.prevent="preSubmit"
        :disabled="!customerData.incomeType.enum" :loading="isLoading" type="submit" id="elCta">
        {{ $t('submit') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { getMaxUboPercentLeft } from '../../../services/UtilService'

export default {
  name: 'ActionFooter',
  props: ['isLoading', 'errMsg'],
  methods: {
    preSubmit () {
      this.$emit('onsubmit')
    },
    handleCheck () {
      this.flags.isChecked = !this.flags.isChecked
    },
    handleBack () {
      this.$store.commit('onboarding/setKeyValue', {
        prop: 'editMode',
        value: true
      })
      this.$router.push({
        name: 'partner-personal-details',
        query: { token: this.partnerToken }
      })
    }
  },
  data () {
    return {
      flags: {
        isChecked: false
      },
      rules: {
        checkbox: [(v) => !!v || '']
      }
    }
  },
  computed: {
    customerData () {
      return this.$store.getters['customer/data']
    },
    isSingleMemberLLC () {
      return this.customerData.incomeType.enum === 'LLC'
    },
    shouldHideConsent () {
      return (
        this.customerData.incomeType.enum === 'DBA' ||
        this.customerData.incomeType.enum === 'SSN' ||
        this.customerData.incomeType.enum === null ||
        this.customerData.incomeType.enum === undefined
      )
    },
    partnerToken () {
      return this.$store.getters['onboarding/partnerToken']
    },
    isMultiBusinessFlow () {
      return this.$store.getters['onboarding/isMultiBusinessFlow']
    },
    isMobile () {
      return this.$store.getters['onboarding/isMobile']
    },
    isSumOwnersPercentValid () {
      const maxUboPercentLeft = getMaxUboPercentLeft(this.customerData)
      if (maxUboPercentLeft < 0) {
        return false
      }
      return (
        maxUboPercentLeft + Number(this.customerData.ownershipPercent) <= 100
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/business-sections/ActionFooter.vue